import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Email message body with optional collapsible quoted thread (plain text only).
 */
export default function EmailMessageBody({ message, channel, isUserBubble }) {
  const [open, setOpen] = useState(false);
  const isEmail = (channel || '').toLowerCase() === 'email';

  if (!isEmail || !message) {
    return <p className="whitespace-pre-wrap leading-relaxed">{message?.content}</p>;
  }

  const meta = message.metadata && typeof message.metadata === 'object' ? message.metadata : {};
  const quoted = (meta.quoted_body || '').trim();
  const textClass = isUserBubble ? 'text-white/85' : 'text-zinc-600';
  const borderClass = isUserBubble ? 'border-white/25' : 'border-brand-border';

  return (
    <div>
      <p className="whitespace-pre-wrap leading-relaxed">{message.content}</p>
      {quoted ? (
        <div className={`mt-2 rounded border ${borderClass} overflow-hidden`}>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className={`flex w-full items-center gap-1 px-2 py-1.5 text-left text-[11px] font-medium ${textClass} hover:opacity-90`}
          >
            {open ? <ChevronDown className="h-3.5 w-3.5 shrink-0" /> : <ChevronRight className="h-3.5 w-3.5 shrink-0" />}
            Hilo citado
          </button>
          {open ? (
            <p className={`whitespace-pre-wrap border-t px-2 py-2 text-[11px] leading-relaxed opacity-90 ${borderClass} ${textClass}`}>
              {quoted}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
